import React from "react";
import PrinterSelectionModal from "../shared/components/PrinterSelectionModal";
import BridgeInstallModal from "../shared/components/BridgeInstallModal";
import ForcePrintDialog from "./ForcePrintDialog";
import ReprintDialog from "./ReprintDialog";
import CustomSnackbar from "../../components/Message.Component";

const OrderModals = ({
  printerModalOpen,
  handleClosePrinterModal,
  availablePrinters,
  selectedPrinter,
  loadingPrinters,
  handleSelectPrinter,
  detectPrinters,
  autoPrintEnabled,
  bridgeInstallModalOpen,
  setBridgeInstallModalOpen,
  downloadProgress,
  downloadBridgeInstaller,
  showForceDialog,
  handleCloseForceDialog,
  handleConfirmForceDialog,
  reprintDialogOpen,
  setReprintDialogOpen,
  pendingReprintOrder,
  onReprintConfirm,
  snackbarOpen,
  handleCloseSnackbar,
  snackbarSeverity,
  snackbarMessage,
}) => {
  return (
    <>
      <PrinterSelectionModal
        type="order"
        open={printerModalOpen}
        onClose={handleClosePrinterModal}
        availablePrinters={availablePrinters}
        selectedPrinter={selectedPrinter}
        loadingPrinters={loadingPrinters}
        onSelectPrinter={handleSelectPrinter}
        onDetectPrinters={detectPrinters}
        autoPrintEnabled={autoPrintEnabled}
      />

      <BridgeInstallModal
        open={bridgeInstallModalOpen}
        onClose={() => setBridgeInstallModalOpen(false)}
        downloadProgress={downloadProgress}
        onDownload={downloadBridgeInstaller}
      />

      <ForcePrintDialog
        open={showForceDialog}
        onCancel={handleCloseForceDialog}
        onConfirm={handleConfirmForceDialog}
      />

      <ReprintDialog
        open={reprintDialogOpen}
        onClose={() => setReprintDialogOpen(false)}
        pendingReprintOrder={pendingReprintOrder}
        onConfirm={onReprintConfirm}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={handleCloseSnackbar}
        severity={snackbarSeverity}
        message={snackbarMessage}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </>
  );
};

export default OrderModals;
